import React from "react";
import {GrCart} from 'react-icons/gr'
import {Link} from "react-router-dom";

const AddCartCircle =({number})=>{
    return(
        <div className={'add-cart-circle'}>
                <div className={"add-cart-circle-icon"}>
                    <Link to={'/cart'}><GrCart size={30}/></Link>
                </div>
                <div className={'add-cart-circle-mini'}>
                    {number}
                </div>
        </div>
    );
}

export default AddCartCircle
